import { MatchHistoryType } from '../enums';

export interface IMissedMatchOffer {
    id: number,

    offerDateTime: string,
    deadlineDateTime: string,
    decisionDateTime: string,
    deadlineMissed: boolean,

    recipientId: number,
    recipientAlias: string,
    recipientCpra4: number,
    recipientCenterId: number,
    recipientCenter: string,

    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenter: string,

    matchHistoryType: MatchHistoryType,

    chainId: number,
    clusterNumber: number,
    positionNumber: number,

    wasAcceptedNoIssues: boolean,
    wasDeclinedUnacceptable: boolean,
    wasAcceptedNotConfident: boolean,
    wasDeclinedUnacceptableAbove99Cpra: boolean,
    wasAcceptedNotConfidentAbove99Cpra: boolean,
    wasDeclinedOther: boolean,
    wasDeclinedSurgeonUnavailable: boolean,
    vxmAccepted: boolean
}